module.exports = __webpack_public_path__ + "static/uni_asu-060b93a612191154495e21341b965995.png";